var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAristonNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#c9102e",
    height: 48,
    rx: 8,
    width: 48
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.1045 24.2386c0-.55 0-.825.1086-1.0685.1085-.2434.3131-.4272.7223-.7947l8.2074-7.3715c1.0611-.9529 1.5916-1.4294 2.2313-1.4294.6396 0 1.1702.4765 2.2312 1.4295l8.2074 7.3714c.4092.3675.6138.5513.7224.7947.1085.2435.1085.5185.1085 1.0685v10.7788c0 1.5741 0 2.3611-.489 2.8501s-1.276.489-2.8501.489h-15.8609c-1.5741 0-2.3611 0-2.8501-.489s-.489-1.276-.489-2.8501zm19.6197 3.8096c-.0012-1.2078-.0023-2.4156-.0023-3.6234-.9172-.8238-1.8336-1.6484-2.75-2.473-1.8639-1.6771-3.7277-3.3541-5.5978-5.0242-1.8701 1.67-3.734 3.3471-5.5978 5.0242-.9165.8246-1.8329 1.6492-2.7501 2.473 0 1.2077-.0011 2.4156-.0023 3.6234-.0023 2.4621-.0047 4.9242.0027 7.3862 5.5648.0167 11.1301.0167 16.6949 0 .0074-2.462.005-4.9241.0027-7.3862z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5127 26.4609 3.8609-3.4435 3.8608 3.4435v5.3217h-7.7217z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m31.5129 9.86958c3.5154 0 6.2609 2.74542 6.2609 6.26092 0 .6915.5606 1.2521 1.2522 1.2521.6915 0 1.2521-.5606 1.2521-1.2521 0-4.8986-3.8667-8.76527-8.7652-8.76527-.6915 0-1.2522.56062-1.2522 1.25218 0 .69155.5607 1.25217 1.2522 1.25217zm2.5044 6.25992c0-1.3825-1.1207-2.5034-2.5044-2.5034-.6915 0-1.2522-.5606-1.2522-1.2522 0-.6915.5607-1.2521 1.2522-1.2521 2.7662 0 5.0087 2.2415 5.0087 5.0077 0 .6916-.5606 1.2531-1.2522 1.2531-.6915 0-1.2521-.5615-1.2521-1.2531zm-1.2522.001c0 .6915-.5606 1.2521-1.2522 1.2521-.6915 0-1.2522-.5606-1.2522-1.2521 0-.6916.5607-1.2522 1.2522-1.2522.6916 0 1.2522.5606 1.2522 1.2522z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAristonNet);
export default __webpack_public_path__ + "static/media/ariston-net.5818630c504d6c422043b75e7cbc187b.svg";
export { ForwardRef as ReactComponent };